export const TOGGLE_SERVICE_PRICEPLAN_BUTTON = 'TOGGLE_SERVICE_PRICEPLAN_BUTTON'
export const toggleServicePricePlanButton = () => ({
    type: TOGGLE_SERVICE_PRICEPLAN_BUTTON
})